import { LMS_BASE_URL } from 'config';

const axios = require('axios');

const fetchStats = () => {
  const requestOtions = {
    withCredentials: true,
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': localStorage.getItem('lms-csrf-token'),
    },
    url: `${LMS_BASE_URL}adminpanel/analytics/stats/`,
  };

  return axios(requestOtions);
};

const fetchLearners = (params) => {
  const requestOtions = {
    withCredentials: true,
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': localStorage.getItem('lms-csrf-token'),
    },
    url: `${LMS_BASE_URL}adminpanel/analytics/learners/`,
    params,
  };

  return axios(requestOtions);
};

const fetchCoursesStats = () => {
  const requestOtions = {
    withCredentials: true,
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': localStorage.getItem('lms-csrf-token'),
    },
    url: `${LMS_BASE_URL}adminpanel/courses/stats/`,
  };

  return axios(requestOtions);
};

/* eslint-disable import/prefer-default-export */
export const analyticsService = {
  fetchStats,
  fetchLearners,
  fetchCoursesStats,
};
